import React from "react";
import QRCode from "react-qr-code";
import { useLocation, useNavigate } from "react-router-dom";
import { TAKEBACK_METHOD_NAME, COUNTRY_NAME } from "consts/query-params";
import { useTranslation } from "react-i18next";
import CloseButton from "components/close-button";

export default function InStoreQR() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const location = useLocation();
  const store = location.pathname.split("/").pop();
  let queryParam = `?${TAKEBACK_METHOD_NAME}=${store}&${COUNTRY_NAME}=US`;

  const qrCodeValue = `https://${window.location.host}${t(
    "urls.signup_store_start"
  )}${queryParam}`;

  return (
    <div className="flex flex-col items-center justify-between h-[calc(100vh-81px)] p-6">
      <CloseButton onClick={() => navigate(-1)} />
      <div className="bg-white flex flex-col my-auto max-w-md items-center">
        <QRCode value={qrCodeValue} size={250} />
        <h1 className="text-6xl font-semibold text-center mt-12">
          Seller registration
        </h1>
        <span className="text-center text-lg text-[#2c2c2c] mt-4">
          Ask the seller to scan the code above with their smartphone to start
          the registration / sign-in process.
        </span>
      </div>
    </div>
  );
}
